import styled from "styled-components";
import { Fit, } from "@bracket/ui/nodes";
import { getTheme, } from "@bracket/ui/themes";



export const TRCell = styled(Fit)<{
	$basisPx?: number;
	$grow?: number;
	$width?: string;
	$minWidth?: string;
	$maxWidth?: string;
	$minHeight?: string;
	$height?: string;
	$maxHeight?: string;
	$align?: string;
	$justify?: string;
	$firstPass?: boolean;
}>`
	display: flex;
	align-items: center;
	padding: 10px 0 10px 0;
	text-align: ${({ $align }) => $align || "left"};
	flex: 1 1 ${({ $basisPx }) => `${$basisPx}px`};
	min-width: ${({ $width }) => $width || "0px"};
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	border-bottom: 1px solid ${() => getTheme().surface_container_high};
	${({ $justify }) => $justify ? `justify-content: ${$justify};` : ""}
	@media (min-width: 768px) {
		width: ${({ $width }) => $width || "auto"};
		min-width: ${({ $firstPass, $width, $minWidth }) => $firstPass ? ($width || "auto") : $minWidth || "auto"};
		max-width: ${({ $firstPass, $width, $maxWidth }) => $firstPass ? ($width || "auto") : $maxWidth || "auto"};
	}

	@media (max-width: 768px) {
		flex-direction: row;
		flex: none;
		width: 100%;
		white-space: normal;
		border-bottom: none;
		padding: 2.5px 0;
		gap: 0.5rem;
	}
`;
